var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[(_vm.isLanding)?_c('Landing'):_vm._e(),(_vm.isConsignee)?_c('Consignee'):_vm._e(),(_vm.isHome)?_c('Home'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }